import { IKlangooNLPConfig } from '../../services/common/nlp/klangoo-config'
import { PageType } from '../../services/common/page-types'
import { Utils } from '../../utils/common'
import { Entity } from '../entity'

// Will be deprecated from FEM v3.10
export interface IAuthor {
    name: string
    wire?: boolean
}

/**
 * writers node under page, newer format for authors, it should
 * replace authors when all sites have latest, same FEM version
 */
export interface IWriter {
    main: IMain[]
    byline?: string
    wire?: string[]
}

export interface IMain {
    name: string
}

export interface IDate {
    mod?: Date
    pub?: Date
    mod_timestamp?: number
    pub_timestamp?: number

}

export interface IVideo {
    ids: string[]
    inPage: boolean
}

export interface ITitle {
    /** @nullable */
    alt?: string
    main?: string
}

export interface IPageAgeGateConfiguration {
    enabled?: boolean
    delayMs?: number
}

export interface IDrivingConfiguration {
    bodyType?: string[]
    vehicleType?: string[]
    specialSection?: string[][]
    modelYears?: string[]
    carMake?: string
    carModel?: string
}

export interface IPageConfiguration {
    ancestry?: string[]
    articleId?: string
    authors?: Array<IAuthor | string>
    date?: IDate
    dist?: string
    error?: number
    /** @nullable */
    excerpt?: string
    isOrigin?: boolean
    klangoo?: IKlangooNLPConfig
    captureUrlParams?: string[]
    globalSlug?: string
    originId?: string
    wpLegacyId?: string
    otherAncestry?: string[][]
    paywall?: string
    responseStatus?: number
    slug?: string
    sponsor?: string
    tags?: string[]
    title?: ITitle
    type: PageType
    video?: IVideo
    wc?: number
    charCount?: number
    wireId?: string
    writers?: IWriter
    isPremium?: boolean
    isPaywallWhitelisted?: boolean
    ageGate?: IPageAgeGateConfiguration
    siteName?: string
    projectType?: string
    drivingTaxonomy?: IDrivingConfiguration
    secondary_categories?: string[]
    abTest?: any
    getTitle?(): string
    getHeadline?(): string
    getCategories?(): string[]
}

export class PageConfiguration extends Entity implements IPageConfiguration {
    public ancestry?: string[]
    public articleId?: string
    public authors?: Array<IAuthor | string>
    public date?: IDate
    public dist?: string
    public error?: number
    /** @nullable */
    public excerpt?: string
    public isOrigin?: boolean
    /** @nullable */
    public klangoo?: IKlangooNLPConfig
    public captureUrlParams?: string[]
    public originId?: string
    public wpLegacyId?: string
    public otherAncestry?: string[][]
    public paywall?: string
    public slug?: string
    public sponsor?: string
    public tags?: string[]
    public title?: ITitle
    public type: PageType
    public video?: IVideo
    public wc?: number
    public charCount?: number
    public wireId?: string
    public writers?: IWriter
    public isPremium?: boolean
    public isPaywallWhitelisted?: boolean
    public ageGate?: IPageAgeGateConfiguration
    public siteName?: string
    public drivingTaxonomy?: IDrivingConfiguration
    public abTest?: any

    public fromJson(jsonObject: object): IPageConfiguration {
        super.fromJson(jsonObject)

        /* parse authors (convert string type to object)
         * to be removed in FEM v3.10
         */
        if ((jsonObject as this).authors) {
            const authors = (jsonObject as this).authors.map((author) =>
                typeof author === 'object' ? author : { name: author } as IMain)
            this.writers = { main: authors }
        }
        // parse writers
        if ((jsonObject as this).writers) {
            this.writers = (jsonObject as this).writers
        }

        // parse date
        if ((jsonObject as this).date) {
            this.date = {}
            if ((jsonObject as this).date.mod) {
                this.date.mod = new Date(Date.parse((jsonObject as any).date.mod))
            }
            if ((jsonObject as this).date.pub) {
                this.date.pub = new Date(Date.parse((jsonObject as any).date.pub))
            }
            if ((jsonObject as this).date.pub_timestamp) {
                this.date.pub_timestamp = (jsonObject as any).date.pub_timestamp
            }
            if ((jsonObject as this).date.mod_timestamp) {
                this.date.mod_timestamp = (jsonObject as any).date.mod_timestamp
            }
        }

        // parse Klangoo
        if ((jsonObject as this).klangoo) {
            this.klangoo = (jsonObject as this).klangoo
        }

        // parse title
        if ((jsonObject as this).title) {
            this.title = (jsonObject as this).title
        }

        // parse video
        if ((jsonObject as this).video) {
            this.video = (jsonObject as this).video
        }

        // parse otherAncestry
        if ((jsonObject as this).otherAncestry) {
            this.otherAncestry = (jsonObject as this).otherAncestry
        }

        // parse ageGate
        if ((jsonObject as this).ageGate) {
            this.ageGate = (jsonObject as this).ageGate
        }

        // parse drivingTaxonomy
        if ((jsonObject as this).drivingTaxonomy) {
            this.drivingTaxonomy = (jsonObject as this).drivingTaxonomy
        }

        // parse abTest
        if ((jsonObject as this).abTest) {
            this.abTest = (jsonObject as this).abTest
        }

        return this
    }

    public getTitle(): string {
        let title = ''
        if (this.title) {
            if (this.title.main) {
                title = Utils.decodeHtmlEntity(this.title.main)
            }
        }
        return title
    }

    public getHeadline(): string {
        let headline = ''
        if (this.title) {
            if (this.title.alt) {
                headline = Utils.decodeHtmlEntity(this.title.alt)
            }
        }
        return headline
    }

    public getCategories(): string[] {
        return this.type === PageType.INDEX && !(this.ancestry && this.ancestry.length) ?
            ['index'] : [...(this.ancestry || [])]
    }

}
